// extracted by mini-css-extract-plugin
module.exports = {"evidence-table-wrapper":"EvidenceTable_evidence-table-wrapper__2qrJK"};